type GroundCollectorLengthLookup = {
  heatingRequirementInKilowattHours: number;
  groundCollectorLengthInMetres: number;
};

export const groundCollectorLengthLookupsByHeatPumpUnitName: Record<string, Array<GroundCollectorLengthLookup>> = {
  'HPG1155U/6-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 600 },
  ],
  'HPG1156S/8-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 400 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 800 },
  ],
  'HPG1155U/12-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 900 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 1400 },
  ],
  'HPG1156S/13-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 900 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 1300 },
  ],
  'HPG1156S/18-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 1000 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1000 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 1800 },
  ],
  'HPG1255U/6-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 600 },
  ],
  'HPG1256S/8-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 400 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 600 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 800 },
  ],
  'HPG1255U/12-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 300 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 900 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 1400 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 1400 },
  ],
  'HPG1256S/13-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 700 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 900 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 1300 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 1300 },
  ],
  'HPG1345N/24(24)-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 800 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1800 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 2100 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 2100 },
  ],
  'HPG1345N/30(30)-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1100 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1600 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1600 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 2000 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 2000 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 2500 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 2500 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 2900 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 2900 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 2900 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 2900 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 2900 },
  ],
  'HPG1345N/40(40)-A': [
    { heatingRequirementInKilowattHours: 10000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 15000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 20000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 25000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 30000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 35000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 40000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 50000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 60000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 70000, groundCollectorLengthInMetres: 1500 },
    { heatingRequirementInKilowattHours: 80000, groundCollectorLengthInMetres: 2000 },
    { heatingRequirementInKilowattHours: 90000, groundCollectorLengthInMetres: 2000 },
    { heatingRequirementInKilowattHours: 100000, groundCollectorLengthInMetres: 2600 },
    { heatingRequirementInKilowattHours: 110000, groundCollectorLengthInMetres: 3200 },
    { heatingRequirementInKilowattHours: 120000, groundCollectorLengthInMetres: 3200 },
    { heatingRequirementInKilowattHours: 130000, groundCollectorLengthInMetres: 3200 },
    { heatingRequirementInKilowattHours: 140000, groundCollectorLengthInMetres: 3200 },
    { heatingRequirementInKilowattHours: 150000, groundCollectorLengthInMetres: 3800 },
  ],
};
